<template>
    <div class="title">
        <a-row type="flex" v-if="!background">
            <a-col class="avatar-container">
                <a-avatar shape="square" :size="96" :src="avatar" />
            </a-col>
            <a-col flex="auto">
                <a-row class="title-main">
                    <a-col class="username-col">
                        <h2 class="username">{{ name }}</h2>
                        <span class="uid">uid: {{ id }}</span>
                    </a-col>
                    <a-col v-if="canFollow" class="follow-col">
                        <a-button v-if="hasFollow" type="dashed" title="取消关注" @click="follow(false)">
                            已关注
                        </a-button>
                        <a-button v-else type="primary" icon="plus" @click="follow(true)">
                            关注
                        </a-button>
                    </a-col>
                </a-row>
                <a-row class="title-vice">
                    <a-col class="sign-col">
                        <span class="sign">{{ sign }}</span>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
        <div v-else>

        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: [ 'name', 'avatar', 'id', 'hasFollow', 'canFollow', 'background', 'sign' ],
    methods: {
        follow(opt) {
            this.$emit("follow", opt);
        }
    }
}
</script>

<style lang="less" scoped>
.title {
    padding: 10px;
}
.avatar-container {
    width: 200px;
    text-align: center;
}
.title-main {
    padding: 16px 0;
    padding-right: 24px;
}
.username {
    color: rgba(0, 0, 0, 0.85);
    font-weight: 600;
    font-size: 20px;
    line-height: 32px;
    display : inline;
}
.uid {
    margin: 5px;
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
    line-height: 22px;
}
@media screen and (min-width: 600px) {
    .title-main {
        display: flex;
    }
    .follow-col {
        margin-left: auto;
    }
}
@media screen and (max-width: 600px) {
    .avatar-container {
        width: 100%;
    }
    .title-main {
        text-align: center;
    }
}
</style>